<template>
  <div class="btnBody">
    <dy-button v-if="prizeDate.id" type="blueText" @click="setShowType">{{
      prizeDate.isShow ? "前台隐藏" : "前台显示"
    }}</dy-button>
    <dy-button v-if="showdel && !prizeDate.id" type="blueText" @click="delPrize">删除</dy-button>
  </div>
</template>
<script>
export default {
  props: {
    // 是否显示删除按钮
    showdel: {
      type: Boolean,
      default: false,
    },
    // 是否单项奖品
    oneprize: {
      type: Boolean,
      default: false,
    },
    // 奖品数据
    prizeDate: {
      type: Object,
      default: () => { },
    },
    // 奖品下标
    prizeIndex: {
      type: Number,
      default: 0,
    },
    // 奖品数组
    prizeList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    delPrize() {
      let list = this.prizeList;
      list.splice(this.prizeIndex, 1);
      this.$emit("update:prizeList", list);
    },
    setShowType() {
      let list = this.prizeList;
      console.log(list);
      let showList = [];
      list.forEach((item) => {
        if (item.isShow) {
          showList.push(item);
        }
      });
      if (this.oneprize) {
        if (!list[this.prizeIndex].isShow) {
          console.log('1');
          
          // 判断有没有其他isShow为1的
          if (showList.filter((item) => item.prizeType).length) {
            this.$message.warning('奖品数量已达上限，不支持继续新增显示！')
          } else {
            list[this.prizeIndex].isShow = list[this.prizeIndex].isShow ? 0 : 1;
            console.log(list[this.prizeIndex].isShow);
            // 删除没有prizeType的数据
            list = this.prizeList.filter((item) => item.prizeType);
            list.forEach((item, index) => {
              if (index != this.prizeIndex && item.prizeType) {
                item.isShow = 0;
              }
            });
            console.log(list, "newList");
          }
        } else {
          console.log('2');
          list[this.prizeIndex].isShow = list[this.prizeIndex].isShow ? 0 : 1;
          if (list.length == 1) {
            list.push({
              isShow: 1,
            });
          } else {
            // 判断有没有其他isShow为1的 如果没有则增加一个
            if (!list.filter((item) => item.isShow).length) {
              list.push({
                isShow: 1,
              });
            }
          }
        }
      } else {
        this.$emit("setIsShow", {
          prizeIndex: this.prizeIndex,
          prizeDate: this.prizeDate,
          isShow: this.prizeDate.isShow,
        });
      }
      this.$emit("update:prizeList", list);
    },
  },
};
</script>
<style lang="scss" scoped>
.btnBody {
  // 转为行内元素
  display: inline-block;
  margin-left: 8px;
}
</style>
